(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["CUSTOM-footerbar"] && !Shopify.designMode) return;
  try {
    
/* Swipe-pijlen voor de mobiele scroll-strip. Scoped per instantie
   (querySelector binnen elke .snoot-fb__scroller), dubbelbinding-veilig via
   een dataset-vlag, en herinitialiseert bij shopify:section:load zodat het
   in de theme editor blijft werken. */
(function () {
  function setup(scroller) {
    if (scroller.dataset.fbReady) return;
    scroller.dataset.fbReady = '1';

    var list = scroller.querySelector('.snoot-fb__list');
    var prev = scroller.querySelector('.snoot-fb__arrow--prev');
    var next = scroller.querySelector('.snoot-fb__arrow--next');
    if (!list || !prev || !next) return;

    function update() {
      var max = list.scrollWidth - list.clientWidth;
      scroller.classList.toggle('is-scrollable', max > 1);
      scroller.classList.toggle('is-at-start', list.scrollLeft <= 1);
      scroller.classList.toggle('is-at-end', list.scrollLeft >= max - 1);
    }

    function step(dir) {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      list.scrollBy({ left: dir * list.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
    }

    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init(root) {
    (root || document).querySelectorAll('.snoot-fb__scroller').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["CUSTOM-producthero"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Vloeiende overgang: eerst uitfaden, dan pas wisselen zodra het
  // nieuwe plaatje is voorgeladen, dan infaden.
  function swapImage(main, src) {
    if (!main || !src) return;
    if (main.getAttribute('src') === src) return;

    var pre = new Image();
    pre.src = src;

    main.style.opacity = '0';

    var revealed = false;
    var reveal = function () {
      if (revealed) return;
      revealed = true;
      main.src = src;
      requestAnimationFrame(function () {
        main.style.opacity = '1';
      });
    };

    setTimeout(function () {
      if (pre.complete) {
        reveal();
      } else {
        pre.onload = reveal;
        pre.onerror = reveal;
      }
    }, 200);

    setTimeout(reveal, 1200);
  }

  function initHero(hero) {
    if (hero.dataset.ptInit) return;
    hero.dataset.ptInit = '1';

    // ── Afbeelding wisselen via thumbnails ──
    var main = hero.querySelector('[data-main-img]');
    hero.querySelectorAll('.snoot-pt-thumb').forEach(function (btn) {
      btn.addEventListener('click', function () {
        swapImage(main, btn.getAttribute('data-src'));
        hero.querySelectorAll('.snoot-pt-thumb').forEach(function (b) {
          b.classList.remove('is-active');
        });
        btn.classList.add('is-active');
      });
    });

    // ── Bundelkiezer -> update prijs + aantal (section-breed) ──
    var qtyInput = hero.querySelector('[data-qty-input]');
    // Prijs kan op meerdere plekken staan (prijsblok + zwevende koopbalk);
    // werk ze allemaal bij vanuit één bron.
    var priceNow = hero.querySelectorAll('[data-price-now]');
    var priceWas = hero.querySelectorAll('[data-price-was]');
    var priceSave = hero.querySelectorAll('[data-price-save]');
    var priceShip = hero.querySelectorAll('[data-price-ship]');
    var perDay = hero.querySelectorAll('[data-per-day]');

    function setText(nodes, text) {
      nodes.forEach(function (n) { n.textContent = text; });
    }
    function setToggle(nodes, text) {
      nodes.forEach(function (n) {
        if (text) {
          n.textContent = text;
          n.style.display = '';
        } else {
          n.style.display = 'none';
        }
      });
    }

    // ── Doseer/voorraad-calculator ────────────────────────────
    // Rekent g/dag uit het hondengewicht en de voorraadduur uit het
    // gekozen bundel-aantal. doseSetQty() wordt door applyOption gevoed.
    var doseSetQty = null;
    var doseRecommend = null;
    var doseEl = hero.querySelector('[data-dose]');
    var doseInput = doseEl && doseEl.querySelector('[data-dose-input]');
    if (doseEl && doseInput) {
      var doseQty = parseInt(doseEl.getAttribute('data-default-qty'), 10) || 1;
      var doseFmt = function (n) {
        var r = Math.round(n * 2) / 2; // afronden op halve gram (schepjes)
        return (r % 1 === 0 ? String(r) : String(r).replace('.', ','));
      };
      var scoopFmt = function (n) {
        n = Math.round(n * 4) / 4; // afronden op kwart schepjes
        if (n < 0.25) { n = 0.25; }
        var whole = Math.floor(n);
        var rem = Math.round((n - whole) * 4); // 0..3 kwarten
        var frac = { 1: '¼', 2: '½', 3: '¾' }[rem] || '';
        var num = whole === 0 ? frac : whole + frac;
        return num + ' ' + (n <= 1 ? 'maatschepje' : 'maatschepjes');
      };
      var doseFill = function (name, value) {
        var el = doseEl.querySelector('[data-dose-line="' + name + '"]');
        if (!el) return;
        var parts = (el.getAttribute('data-tpl') || '{v}').split('{v}');
        el.textContent = parts[0] || '';
        var strong = document.createElement('strong');
        strong.textContent = value;
        el.appendChild(strong);
        el.appendChild(document.createTextNode(parts[1] || ''));
      };
      var doseRender = function () {
        var dg = parseFloat(doseEl.getAttribute('data-dose-grams')) || 2;
        var dk = parseFloat(doseEl.getAttribute('data-dose-kg')) || 10;
        var pot = parseFloat(doseEl.getAttribute('data-pot-grams')) || 120;
        var min = parseFloat(doseInput.min) || 1;
        var max = parseFloat(doseInput.max) || 999;
        var w = parseFloat(doseInput.value);
        if (isNaN(w)) { w = min; }
        w = Math.min(max, Math.max(min, w));
        var perDay = dk > 0 ? (w / dk * dg) : dg;
        if (perDay <= 0) { perDay = dg; }
        var round5 = function (x) { return Math.max(5, Math.round(x / 5) * 5); };
        var scoopG = parseFloat(doseEl.getAttribute('data-scoop-grams')) || 2;
        doseFill('perday', doseFmt(perDay) + ' g');
        doseFill('scoops', scoopFmt(scoopG > 0 ? perDay / scoopG : 0));

        // Pakkettegels: voorraad-dagen dynamisch op het gewicht.
        var tiles = hero.querySelectorAll('.snoot-pt-bundle__option');
        tiles.forEach(function (t) {
          var el = t.querySelector('[data-bundle-days]');
          if (el) el.textContent = '~' + round5((parseFloat(t.getAttribute('data-qty')) || 1) * pot / perDay) + ' dagen';
        });

        // Adviesbadge op het aanbevolen pakket, meebewegend met het gewicht.
        var recT = recommendedTile();
        var wLbl = (w % 1 === 0) ? String(w) : String(w).replace('.', ',');
        tiles.forEach(function (t) {
          var b = t.querySelector('[data-advice-badge]');
          if (!b) return;
          if (t === recT) { b.textContent = 'Ons advies voor uw hond (' + wLbl + ' kg)'; b.hidden = false; }
          else { b.hidden = true; }
        });

        // Onder de hoofdprijs: prijs/dag · dagen voorraad (bij gewicht) van de gekozen bundel.
        var sel = hero.querySelector('.snoot-pt-bundle__option.is-selected') || tiles[0];
        var selQty = sel ? (parseFloat(sel.getAttribute('data-qty')) || doseQty) : doseQty;
        var selDays = round5(selQty * pot / perDay);
        doseFill('supply', selDays + ' dagen');
        if (sel) {
          var cents = parseFloat(sel.getAttribute('data-total-cents')) || 0;
          var perDayEuro = selDays > 0 ? (cents / 100) / selDays : 0;
          var wTxt = (w % 1 === 0) ? String(w) : String(w).replace('.', ',');
          var sentence = '~€' + perDayEuro.toFixed(2).replace('.', ',') + ' per dag · ' + wTxt + ' kg gewicht hond · ~' + selDays + ' dagen voorraad';
          hero.querySelectorAll('[data-per-day]').forEach(function (n) { n.textContent = sentence; });
        }
      };
      // Aanbevolen pakket: kleinste bundel die ~advies-dagen voorraad haalt
      // (bij het ingevulde gewicht), begrensd door het grootste pakket.
      var recommendedTile = function () {
        var dg = parseFloat(doseEl.getAttribute('data-dose-grams')) || 2;
        var dk = parseFloat(doseEl.getAttribute('data-dose-kg')) || 10;
        var pot = parseFloat(doseEl.getAttribute('data-pot-grams')) || 120;
        var adviceDays = parseFloat(doseEl.getAttribute('data-advice-days')) || 60;
        var w = parseFloat(doseInput.value); if (isNaN(w)) { w = 1; }
        var perDay = dk > 0 ? (w / dk * dg) : dg; if (perDay <= 0) { perDay = dg; }
        var recPots = Math.max(1, Math.ceil(perDay * adviceDays / pot));
        var tiles = hero.querySelectorAll('.snoot-pt-bundle__option');
        var best = null, bestQ = null;
        tiles.forEach(function (t) {
          var q = parseFloat(t.getAttribute('data-qty')) || 1;
          if (q >= recPots && (best === null || q < bestQ)) { best = t; bestQ = q; }
        });
        if (!best) tiles.forEach(function (t) {
          var q = parseFloat(t.getAttribute('data-qty')) || 1;
          if (best === null || q > bestQ) { best = t; bestQ = q; }
        });
        return best;
      };
      // Selecteer het aanbevolen pakket (tenzij het al geselecteerd is).
      var applyRecommendation = function () {
        var t = recommendedTile();
        if (t && !t.classList.contains('is-selected') && typeof applyOption === 'function') applyOption(t);
      };

      var doseStep = function (dir) {
        var step = parseFloat(doseInput.step) || 1;
        var min = parseFloat(doseInput.min) || 1;
        var max = parseFloat(doseInput.max) || 999;
        var v = (parseFloat(doseInput.value) || min) + dir * step;
        doseInput.value = Math.min(max, Math.max(min, v));
        doseRender();
        applyRecommendation();
      };
      var doseDec = doseEl.querySelector('[data-dose-dec]');
      var doseInc = doseEl.querySelector('[data-dose-inc]');
      if (doseDec) doseDec.addEventListener('click', function () { doseStep(-1); });
      if (doseInc) doseInc.addEventListener('click', function () { doseStep(1); });
      var doseClamp = function () {
        var min = parseFloat(doseInput.min) || 1;
        var max = parseFloat(doseInput.max) || 100;
        var v = parseFloat(doseInput.value);
        if (isNaN(v)) { v = min; }
        doseInput.value = Math.min(max, Math.max(min, v));
        doseRender();
      };
      doseInput.addEventListener('input', doseRender);
      doseInput.addEventListener('change', function () { doseClamp(); applyRecommendation(); });
      doseSetQty = function (qty) { doseQty = parseInt(qty, 10) || doseQty; doseRender(); };
      doseRecommend = applyRecommendation;
      doseRender();
    }

    // Eén selectiebron voor de bundelkeuze: zowel de tegels in het
    // koopblok als de compacte tegels in de zwevende balk roepen
    // applyOption aan, zodat prijs, aantal en actieve staat overal
    // synchroon blijven.
    var bundleOpts = hero.querySelectorAll('.snoot-pt-bundle__option');
    var buybarTiers = hero.querySelectorAll('[data-buybar-qty]');
    function applyOption(opt) {
      if (!opt) return;
      var qty = opt.getAttribute('data-qty');
      bundleOpts.forEach(function (o) {
        var on = o === opt;
        o.classList.toggle('is-selected', on);
        o.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      buybarTiers.forEach(function (t) {
        var on = t.getAttribute('data-buybar-qty') === qty;
        t.classList.toggle('is-selected', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (qtyInput) qtyInput.value = qty;
      if (opt.dataset.total) setText(priceNow, opt.dataset.total);
      setToggle(priceWas, opt.dataset.was);
      setToggle(priceSave, opt.dataset.save);
      priceShip.forEach(function (n) { n.style.display = opt.dataset.freeship === '1' ? '' : 'none'; });
      if (doseSetQty) doseSetQty(qty);
    }
    bundleOpts.forEach(function (opt) {
      opt.addEventListener('click', function () { applyOption(opt); });
    });
    buybarTiers.forEach(function (tier) {
      tier.addEventListener('click', function () {
        var qty = tier.getAttribute('data-buybar-qty');
        var match = null;
        bundleOpts.forEach(function (o) { if (o.getAttribute('data-qty') === qty) match = o; });
        applyOption(match);
      });
    });

    // Initiële selectie op het aanbevolen pakket (nu applyOption + tegels klaar zijn).
    if (doseRecommend) doseRecommend();

    // ── Variantkeuze ──
    hero.querySelectorAll('.snoot-pt-variant input[type="radio"]').forEach(function (input) {
      input.addEventListener('change', function () {
        hero.querySelectorAll('.snoot-pt-variant').forEach(function (l) {
          l.classList.remove('is-selected');
        });
        var label = input.closest('.snoot-pt-variant');
        if (label) label.classList.add('is-selected');
      });
    });

    // ── Zwevende koopbalk: tonen bij scrollen + submit delegeren ──
    var buybar = hero.querySelector('[data-buybar]');
    var mainCta = hero.querySelector('.snoot-pt-cta');
    if (buybar && mainCta) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            // Toon de balk pas als de hoofd-CTA boven de viewport uit is gescrold.
            var past = !e.isIntersecting && e.boundingClientRect.top < 0;
            buybar.classList.toggle('is-visible', past);
            buybar.setAttribute('aria-hidden', past ? 'false' : 'true');
            // Publiceer de bezette onderruimte zodat schermvullende secties
            // (o.a. de gepinde Timeline) hun onderrand erboven kunnen houden.
            document.documentElement.style.setProperty('--snoot-bottom-inset', past ? buybar.offsetHeight + 'px' : '0px');
          });
        }, { threshold: 0 });
        io.observe(mainCta);
      }

      // Standaard is de knop via form="snoot-pt-form" gekoppeld aan het
      // hoofdformulier en voegt de gekozen bundel direct toe aan de
      // winkelwagen. Staat de editor-optie op 'scroll', dan is het een
      // gewone knop die terugscrolt naar het koopblok bovenaan.
      var scrollBtn = buybar.querySelector('[data-buybar-scroll]');
      if (scrollBtn) {
        scrollBtn.addEventListener('click', function () {
          hero.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    }

    // ── Vloeiend openen/sluiten van de uitklappers. Native <details> doet
    //    dit instant; door de hoogte te animeren groeit de infokolom
    //    geleidelijk, zodat de sticky galerij mee-glijdt i.p.v. te
    //    verspringen. Respecteert prefers-reduced-motion.
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduceMotion) {
      var accRows = [];
      hero.querySelectorAll('.snoot-pt-acc__row').forEach(function (row) {
        var head = row.querySelector('.snoot-pt-acc__head');
        var body = row.querySelector('.snoot-pt-acc__body');
        if (!head || !body) return;
        var busy = false;
        function closeRow() {
          if (busy || !row.open) return;
          busy = true;
          body.style.height = body.scrollHeight + 'px';
          body.getBoundingClientRect();
          body.addEventListener('transitionend', function done(ev) {
            if (ev.propertyName !== 'height') return;
            body.removeEventListener('transitionend', done);
            row.open = false;
            body.style.height = '';
            busy = false;
          });
          requestAnimationFrame(function () { body.style.height = '0px'; });
        }
        function openRow() {
          if (busy || row.open) return;
          busy = true;
          row.open = true;
          var target = body.scrollHeight;
          body.style.height = '0px';
          body.getBoundingClientRect();
          body.addEventListener('transitionend', function done(ev) {
            if (ev.propertyName !== 'height') return;
            body.removeEventListener('transitionend', done);
            body.style.height = '';
            busy = false;
          });
          requestAnimationFrame(function () { body.style.height = target + 'px'; });
        }
        accRows.push({ row: row, close: closeRow });
        head.addEventListener('click', function (e) {
          e.preventDefault();
          if (busy) return;
          if (row.open) {
            closeRow();
          } else {
            // Accordeon: sluit andere open rijen, zodat er altijd max. één open is.
            accRows.forEach(function (r) { if (r.row !== row) r.close(); });
            openRow();
          }
        });
      });
    }
  }

  // ── Prijs-per-pot: consistent samen "springen" ──
  // Op mobiel staat de per-pot inline naast het aantal potten. Omdat "1 pot" smaller
  // is dan "2/3 potten", past 'ie daar soms wél inline en bij de rest niet — dan
  // sprong alleen een deel van de tegels een regel omlaag. Deze functie meet of de
  // per-pot bij ÉÉN tegel naar een tweede regel wrapt; zo ja, dan zet 'ie 'm bij ALLE
  // tegels op een eigen regel (.is-perpot-stacked). Passen ze allemaal inline, dan
  // blijft 'ie overal inline. Zo springen ze altijd sámen.
  function syncPerpot() {
    document.querySelectorAll('.snoot-pt-bundle__options').forEach(function (group) {
      group.classList.remove('is-perpot-stacked'); // eerst meten in inline-stand
      var wrapped = false;
      group.querySelectorAll('.snoot-pt-bundle__option').forEach(function (box) {
        var qty = box.querySelector('.snoot-pt-bundle__qty');
        var pp = box.querySelector('.snoot-pt-bundle__perpot--inline');
        if (!qty || !pp) return;
        var pr = pp.getBoundingClientRect();
        if (pr.width === 0) return; // verborgen (desktop-variant): overslaan
        var qr = qty.getBoundingClientRect();
        // pp staat op een eigen (tweede) regel als 'ie links tegen de qty-rand
        // begint i.p.v. ná het label. Tops vergelijken faalt: de kleinere per-pot-
        // tekst ligt door baseline-uitlijning al iets lager op DEZELFDE regel.
        if (pr.left - qr.left < 4) wrapped = true;
      });
      if (wrapped) group.classList.add('is-perpot-stacked');
    });
  }
  var perpotRaf = 0;
  function schedulePerpot() {
    if (perpotRaf) return;
    perpotRaf = requestAnimationFrame(function () { perpotRaf = 0; syncPerpot(); });
  }

  function boot() {
    document.querySelectorAll('.snoot-pt-hero').forEach(initHero);
    syncPerpot();
  }

  if (document.readyState !== 'loading') {
    boot();
  } else {
    document.addEventListener('DOMContentLoaded', boot);
  }
  // Herbereken na volledige load + zodra de webfonts klaar zijn (tekstbreedte
  // verandert dan) en bij elke resize (via rAF, tegen thrashing).
  window.addEventListener('load', syncPerpot);
  if (document.fonts && document.fonts.ready) { document.fonts.ready.then(syncPerpot); }
  window.addEventListener('resize', schedulePerpot, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
